export default "__VITE_ASSET__KmMIvyQc__"